<mat-accordion *ngIf="businessPersonWithTrainingSkeletons; else noStaff">
  <mat-expansion-panel
    *ngFor="let businessPersonWithTrainingSkeleton of businessPersonWithTrainingSkeletons"
  >
    <mat-expansion-panel-header>{{
      businessPersonWithTrainingSkeleton.name
    }}</mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <sd-portal-staff-member-audit-list
        [loading]="loading"
        [audits]="audits"
        [businessPersonTrainingRequirements]="
          businessPersonWithTrainingSkeleton.businessPersonTrainingRequirements
        "
        (opened)="onOpened($event)"
      >
      </sd-portal-staff-member-audit-list>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #noStaff> No staff to audit </ng-template>
